<template>
  <FeatureRow :category-label="categoryDisplayLabel" :on-click="props.onClick" :thumbnail-url="hit.feature.thumbnailUrl" :title="hit.feature.title" :to="path" />
</template>

<script setup lang="ts">
import FeatureRow from '@/wabunka-src/features/Search/components/model/FeatureRow.vue';
import type { AlgoliaFeatureHit } from '@/wabunka-src/features/Search/models/algoliaHit';
import { getFeatureCategoryDisplayLabel } from '@/wabunka-src/features/Search/models/algoliaHit';
import { buildFeaturePath } from '@/wabunka-src/features/Search/models/algoliaHitLink';

interface Props {
  hit: AlgoliaFeatureHit;
  onClick?: () => void;
}

const props = defineProps<Props>();

const path = computed(() => buildFeaturePath(props.hit));
const categoryDisplayLabel = computed(() => getFeatureCategoryDisplayLabel(props.hit));
</script>
